<template>
  <v-card class="card-container">
    <v-dialog v-model="deleteDialog" persistent :key="deleteDialogKey">
      <v-card class="card-pad pa-4 text-center">
        <h3>{{ $t('Remover fabricante padrão') }}</h3>
        <p class="my-3">
          {{ $t('Tem certeza que deseja remover o fabricante') }}
          {{ manufacturer.name }}?
        </p>
        <div class="ma-2 d-flex justify-center">
          <v-btn class="primary-button" depressed @click="deleteDialog = false">
            Cancelar
          </v-btn>
          <v-btn class="secondary-button mr-0" depressed @click="remove">
            {{ $t('Confirmar') }}
          </v-btn>
        </div>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog" persistent max-width="400">
      <Manage
        :key="dialogKey"
        :id="manufacturer.id"
        @close="dialog = false"
        @confirm=";(dialog = false), (dialogKey = !dialogKey), list()"
      />
    </v-dialog>

    <div class="main-toolbar mb-4">
      <div class="icon-back">
        <v-icon color="white" size="30">mdi-factory</v-icon>
      </div>

      <span class="main-toolbar-title">{{
        $t('Cadastro Padrão - Fabricantes Padrão')
      }}</span>

      <v-spacer></v-spacer>

      <v-btn
        class="secondary-button ma-1 mt-2"
        depressed
        dark
        @click="exportExcel"
      >
        Exportar
      </v-btn>

      <v-btn
        @click=";(dialogKey = !dialogKey), (manufacturer = {}), (dialog = true)"
        depressed
        dark
        class="ma-1 secondary-button mt-2"
      >
        {{ $t('Adicionar') }}
      </v-btn>

      <v-btn
        class="primary-button ma-1 mr-0 mt-2"
        depressed
        @click="show = !show"
      >
        {{ show ? $t('Fechar') : 'Filtros' }}
      </v-btn>
    </div>

    <v-expand-transition>
      <div v-show="show">
        <v-row class="ma-0" align="center" justify="end" dense>
          <v-col cols="12" sm="5">
            <v-text-field
              hide-details="auto"
              outlined
              class="primary-input"
              v-model="filter.name"
              :placeholder="$t('Pesquisar por nome')"
              @keyup.enter=";(filter.page = 1), list()"
            ></v-text-field>
          </v-col>
        </v-row>
        <div class="d-flex justify-end">
          <v-btn
            class="clear-button mr-2"
            depressed
            @click="
              filter = {
                page: 1,
              }
            "
          >
            {{ $t('Limpar') }}
          </v-btn>
          <v-btn
            class="secondary-button"
            depressed
            @click=";(filter.page = 1), list()"
          >
            {{ $t('Aplicar filtros') }}
          </v-btn>
        </div>
      </div>
    </v-expand-transition>

    <v-data-table
      :loading="loading"
      hide-default-header
      :loading-text="$t('Carregando...')"
      :no-data-text="$t('Nenhum fabricante encontrado')"
      :items="manufacturers"
      :headers="headers"
      class="main-table"
      hide-default-footer
      :items-per-page="filter.pageSize"
      mobile-breakpoint="0"
    >
      <template #header="{ props, on }">
        <thead>
          <tr>
            <th
              class="text-center"
              v-for="header in props.headers"
              :key="header.value"
            >
              <v-simple-checkbox
                v-if="header.value === 'data-table-select'"
                v-model="props.everyItem"
                :indeterminate="props.someItems && !props.everyItem"
                color="purple"
                @input="on['toggle-select-all']"
              ></v-simple-checkbox>

              <div>
                <v-hover v-slot="{ hover }">
                  <div>
                    <span>{{ $t(header.text) }}</span>
                    <v-icon
                      v-if="
                        hover &&
                        header.value != 'data-table-select' &&
                        header.value != 'actions'
                      "
                      color="white"
                      class="mx-2"
                      @click="on.sort(header.value)"
                    >
                      {{
                        props.options.sortBy.includes(header.value)
                          ? `mdi-chevron-down`
                          : `mdi-chevron-up`
                      }}
                    </v-icon>
                  </div>
                </v-hover>
              </div>
            </th>
          </tr>
        </thead>
      </template>

      <template #[`item.actions`]="{ item }">
        <v-tooltip bottom>
          <template #activator="{ on }">
            <v-btn
              class="ma-1"
              color="#0F3565"
              dark
              small
              depressed
              v-on="on"
              @click="
                ;(dialogKey = !dialogKey),
                  (manufacturer = item),
                  (dialog = true)
              "
            >
              <v-icon size="22">mdi-pencil-outline</v-icon>
            </v-btn>
          </template>
          <span>Editar</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template #activator="{ on }">
            <v-btn
              class="ma-1"
              color="#921616"
              depressed
              small
              v-on="on"
              @click="
                ;(deleteDialogKey = !deleteDialogKey),
                  (manufacturer = item),
                  (deleteDialog = true)
              "
            >
              <v-icon size="22" color="white">mdi-trash-can-outline</v-icon>
            </v-btn>
          </template>
          <span>{{ $t('Excluir') }}</span>
        </v-tooltip>
      </template>
    </v-data-table>

    <div class="pagination mx-2">
      <div class="item-pagination block-one">
        <v-menu bottom offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              class="btn"
              depressed
              color="#C0C0C0"
              small
            >
              qtd: {{ filter.pageSize }}
            </v-btn>
          </template>
          <v-list>
            <v-list-item
              v-for="(size, i) in sizes"
              :key="i"
              @click="filter.pageSize = size"
            >
              <v-list-item-title>{{ size }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <div class="registros" v-if="manufacturers.length">
          <span>
            1 - {{ manufacturers.length }} de {{ filter.totalItems }}
          </span>
        </div>
      </div>

      <div class="item-pagination block-two">
        <v-pagination
          class="pagination-item"
          v-model="filter.page"
          :length="filter.totalPages"
          :total-visible="5"
        ></v-pagination>
      </div>
    </div>
  </v-card>
</template>

<script>
import ApiService from '../../../services/ApiService'
import Manage from './components/manage.vue'

export default {
  name: 'StandardManufacturerPage',

  components: {
    Manage,
  },

  created() {
    this.list()
  },

  data() {
    return {
      apiService: new ApiService(),
      loading: false,
      sizes: [10, 30, 90, 180],
      filter: {
        page: 1,
        pageSize: 10,
      },
      manufacturer: {},
      manufacturers: [],
      show: false,
      dialog: false,
      dialogKey: false,
      deleteDialog: false,
      deleteDialogKey: false,
      headers: [
        {
          text: '',
          align: 'center',
          value: '',
        },
        {
          text: 'Nome',
          align: 'center',
          value: 'name',
        },
        {
          text: '',
          align: 'center',
          value: 'actions',
        },
      ],
    }
  },

  methods: {
    exportExcel() {
      this.apiService.get('standardManufacturer/excel').then((response) => {
        var excelResult = `data:application/octet-stream;base64,${response.content}`
        const link = document.createElement('a')
        link.href = excelResult
        link.setAttribute('download', `FabricantesPadrão.xlsx`)
        document.body.appendChild(link)
        link.click()
      })
    },

    list() {
      this.apiService
        .post('standardManufacturer/list/paginated', this.filter)
        .then((response) => {
          this.manufacturers = response.content.manufacturers
          this.filter.page = response.content.pager.currentPage
          this.filter.totalPages = response.content.pager.totalPages
          this.filter.totalItems = response.content.pager.totalItems
        })
    },

    remove() {
      this.apiService
        .delete(`standardManufacturer/delete/${this.manufacturer.id}`)
        .then((response) => {
          this.manufacturer = {}
          this.$toast.success('Fabricante removida com sucesso!')
          this.deleteDialog = false
          this.list()
        })
    },
  },

  watch: {
    'filter.pageSize': {
      deep: true,
      handler() {
        this.list()
      },
    },

    'filter.page': {
      deep: true,
      handler() {
        this.list()
      },
    },
  },
}
</script>

<style scoped></style>
